import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取平台信息设置详情 **/
    GET_SETTING_DETAILS(data) {
        controller='Platsetting';
        action='GetSettingDetails';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改平台信息设置 **/
    UPDATE_SETTING(data) {
        controller='Platsetting';
        action='UpdateSetting';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 修改平台信息值 **/
    UPDATE_SETTING_VALUE(data) {
        controller='Platsetting';
        action='UpdateSettingValue';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 查看超级日志信息 **/
    CHECK_SUPER_LOG(data) {
        controller='Platsetting';
        action='GetSuperLog';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}